export const GENDERS = [
    {
        label: 'All genders',
        value: null,
    },
    {
        label: 'Male',
        value: 'male',
    },
    {
        label: 'Female',
        value: 'female',
    },
];

export const BREEDS = (breeds = []) => [
    {
        label: 'All breeds',
        value: null,
    },
    ...breeds.map((b) => ({ label: b.breed == 'mix' ? 'Mix' : b.breed, value: b.shortSlug })),
];

export const STATES = [
    {
        label: 'All States',
        value: null,
    },
    {
        label: 'Alabama',
        value: 'alabama',
    },
    {
        label: 'Alaska',
        value: 'alaska',
    },
    {
        label: 'Arizona',
        value: 'arizona',
    },
    {
        label: 'Arkansas',
        value: 'arkansas',
    },
    {
        label: 'California',
        value: 'california',
    },
    {
        label: 'Colorado',
        value: 'colorado',
    },
    {
        label: 'Connecticut',
        value: 'connecticut',
    },
    {
        label: 'Delaware',
        value: 'delaware',
    },
    {
        label: 'District of Columbia',
        value: 'district-of-columbia',
    },
    {
        label: 'Florida',
        value: 'florida',
    },
    {
        label: 'Georgia',
        value: 'georgia',
    },
    {
        label: 'Hawaii',
        value: 'hawaii',
    },
    {
        label: 'Idaho',
        value: 'idaho',
    },
    {
        label: 'Illinois',
        value: 'illinois',
    },
    {
        label: 'Indiana',
        value: 'indiana',
    },
    {
        label: 'Iowa',
        value: 'iowa',
    },
    {
        label: 'Kansas',
        value: 'kansas',
    },
    {
        label: 'Kentucky',
        value: 'kentucky',
    },
    {
        label: 'Louisiana',
        value: 'louisiana',
    },
    {
        label: 'Maine',
        value: 'maine',
    },
    {
        label: 'Maryland',
        value: 'maryland',
    },
    {
        label: 'Massachusetts',
        value: 'massachusetts',
    },
    {
        label: 'Michigan',
        value: 'michigan',
    },
    {
        label: 'Minnesota',
        value: 'minnesota',
    },
    {
        label: 'Mississippi',
        value: 'mississippi',
    },
    {
        label: 'Missouri',
        value: 'missouri',
    },
    {
        label: 'Montana',
        value: 'montana',
    },
    {
        label: 'Nebraska',
        value: 'nebraska',
    },
    {
        label: 'Nevada',
        value: 'nevada',
    },
    {
        label: 'New Hampshire',
        value: 'new-hampshire',
    },
    {
        label: 'New Jersey',
        value: 'new-jersey',
    },
    {
        label: 'New Mexico',
        value: 'new-mexico',
    },
    {
        label: 'New York',
        value: 'new-york',
    },
    {
        label: 'North Carolina',
        value: 'north-carolina',
    },
    {
        label: 'North Dakota',
        value: 'north-dakota',
    },
    {
        label: 'Ohio',
        value: 'ohio',
    },
    {
        label: 'Oklahoma',
        value: 'oklahoma',
    },
    {
        label: 'Oregon',
        value: 'oregon',
    },
    {
        label: 'Pennsylvania',
        value: 'pennsylvania',
    },
    {
        label: 'Rhode Island',
        value: 'rhode-island',
    },
    {
        label: 'South Carolina',
        value: 'south-carolina',
    },
    {
        label: 'South Dakota',
        value: 'south-dakota',
    },
    {
        label: 'Tennessee',
        value: 'tennessee',
    },
    {
        label: 'Texas',
        value: 'texas',
    },
    {
        label: 'Utah',
        value: 'utah',
    },
    {
        label: 'Vermont',
        value: 'vermont',
    },
    {
        label: 'Virginia',
        value: 'virginia',
    },
    {
        label: 'Washington',
        value: 'washington',
    },
    {
        label: 'West Virginia',
        value: 'west-virginia',
    },
    {
        label: 'Wisconsin',
        value: 'wisconsin',
    },
    {
        label: 'Wyoming',
        value: 'wyoming',
    },
];

export const NEARBY_STATES = {
    alabama: ['Florida', 'Georgia', 'Mississippi', 'Tennessee'],
    arizona: ['California', 'Colorado', 'Nevada', 'New Mexico', 'Utah'],
    arkansas: ['Louisiana', 'Mississippi', 'Missouri', 'Oklahoma', 'Tennessee', 'Texas'],
    california: ['Arizona', 'Nevada', 'Oregon'],
    colorado: ['Arizona', 'Kansas', 'Nebraska', 'New Mexico', 'Oklahoma', 'Utah', 'Wyoming'],
    connecticut: ['Massachusetts', 'New York', 'Rhode Island'],
    delaware: ['Maryland', 'New Jersey', 'Pennsylvania'],
    'district-of-columbia': ['Maryland', 'Virginia'],
    florida: ['Alabama', 'Georgia'],
    georgia: ['Alabama', 'Florida', 'North Carolina', 'South Carolina', 'Tennessee'],
    idaho: ['Montana', 'Nevada', 'Oregon', 'Utah', 'Washington', 'Wyoming'],
    illinois: ['Indiana', 'Iowa', 'Michigan', 'Kentucky', 'Missouri', 'Wisconsin'],
    indiana: ['Illinois', 'Kentucky', 'Michigan', 'Ohio'],
    iowa: ['Illinois', 'Minnesota', 'Missouri', 'Nebraska', 'South Dakota', 'Wisconsin'],
    kansas: ['Colorado', 'Missouri', 'Nebraska', 'Oklahoma'],
    kentucky: ['Illinois', 'Indiana', 'Missouri', 'Ohio', 'Tennessee', 'Virginia', 'West Virginia'],
    louisiana: ['Arkansas', 'Mississippi', 'Texas'],
    maine: ['New Hampshire'],
    maryland: ['Delaware', 'District of Columbia', 'Pennsylvania', 'Virginia', 'West Virginia'],
    massachusetts: ['Connecticut', 'New Hampshire', 'New York', 'Rhode Island', 'Vermont'],
    michigan: ['Illinois', 'Indiana', 'Minnesota', 'Ohio', 'Wisconsin'],
    minnesota: ['Iowa', 'Michigan', 'North Dakota', 'South Dakota', 'Wisconsin'],
    mississippi: ['Alabama', 'Arkansas', 'Louisiana', 'Tennessee'],
    missouri: ['Arkansas', 'Illinois', 'Iowa', 'Kansas', 'Kentucky', 'Nebraska', 'Oklahoma', 'Tennessee'],
    montana: ['Idaho', 'North Dakota', 'South Dakota', 'Wyoming'],
    nebraska: ['Colorado', 'Iowa', 'Kansas', 'Missouri', 'South Dakota', 'Wyoming'],
    nevada: ['Arizona', 'California', 'Idaho', 'Oregon', 'Utah'],
    'new-hampshire': ['Maine', 'Massachusetts', 'Vermont'],
    'new-jersey': ['Delaware', 'New York', 'Pennsylvania'],
    'new-mexico': ['Arizona', 'Colorado', 'Oklahoma', 'Texas', 'Utah'],
    'new-york': ['Connecticut', 'Massachusetts', 'New Jersey', 'Pennsylvania', 'Rhode Island', 'Vermont'],
    'north-carolina': ['Georgia', 'South Carolina', 'Tennessee', 'Virginia'],
    'north-dakota': ['Minnesota', 'Montana', 'South Dakota'],
    ohio: ['Indiana', 'Kentucky', 'Michigan', 'Pennsylvania', 'West Virginia'],
    oklahoma: ['Arkansas', 'Colorado', 'Kansas', 'Missouri', 'New Mexico', 'Texas'],
    oregon: ['California', 'Idaho', 'Nevada', 'Washington'],
    pennsylvania: ['Delaware', 'Maryland', 'New Jersey', 'New York', 'Ohio', 'West Virginia'],
    'rhode-island': ['Connecticut', 'Massachusetts', 'New York'],
    'south-carolina': ['Georgia', 'North Carolina'],
    'south-dakota': ['Iowa', 'Minnesota', 'Montana', 'Nebraska', 'North Dakota', 'Wyoming'],
    tennessee: ['Alabama', 'Arkansas', 'Georgia', 'Kentucky', 'Mississippi', 'Missouri', 'North Carolina', 'Virginia'],
    texas: ['Arkansas', 'Louisiana', 'New Mexico', 'Oklahoma'],
    utah: ['Arizona', 'Colorado', 'Idaho', 'Nevada', 'New Mexico', 'Wyoming'],
    vermont: ['Massachusetts', 'New Hampshire', 'New York'],
    virginia: ['District of Columbia', 'Kentucky', 'Maryland', 'North Carolina', 'Tennessee', 'West Virginia'],
    washington: ['Idaho', 'Oregon'],
    'west-virginia': ['Kentucky', 'Maryland', 'Ohio', 'Pennsylvania', 'Virginia'],
    wisconsin: ['Illinois', 'Iowa', 'Michigan', 'Minnesota'],
    wyoming: ['Colorado', 'Idaho', 'Montana', 'Nebraska', 'South Dakota', 'Utah'],
};

export const SORT_BY = [
    {
        label: 'Rank ascending',
        value: 'RANK_ASC',
    },
    {
        label: 'Rank descending',
        value: 'RANK_DESC',
    },
    {
        label: 'Name A-Z',
        value: 'NAME_ASC',
    },
    {
        label: 'Name Z-A',
        value: 'NAME_DESC',
    },
];

export const DEFAULT_FAQS = [
    {
        question: 'How do I choose the best name for my female dog?',
        answer: 'For the perfect dog name, consider their personality and looks, keep it short, and avoid command-like names. Test a few to see which one fits and feels right for both of you.',
    },
    {
        question: 'Can the breed of my dog influence the name I choose?',
        answer: 'Absolutely! Certain breeds might evoke specific themes or characteristics that could inspire a name. For instance, a Husky might bring to mind names associated with the Arctic or snow, while a Dachshund might inspire names with German origins.',
    },
    {
        question: "Should I pick a name based on my dog's home state in the USA?",
        answer: "It's a fun idea! You could explore names that are related to landmarks, cities, or cultural elements of your state. For example, if you're from California, names like Sierra, Sunny, or Hollywood might resonate.",
    },
    {
        question: 'What are some popular names for male dogs?',
        answer: 'Popular names for male dogs often include strong, timeless choices like Max, Charlie, Buddy, or Rocky. These names can suit a variety of breeds and personalities.',
    },
    {
        question: "How can I ensure my dog's name is unique?",
        answer: 'Researching popular dog names can help you avoid common choices. Additionally, you might consider unique names from literature, mythology, or different languages.',
    },
    {
        question: "Can I choose a name based on my dog's physical features?",
        answer: "Absolutely! Observing your dog's appearance can lead to creative name ideas. For example, if your dog has a fluffy white coat, names like Snowball or Cotton could be fitting.",
    },
    {
        question: 'Should I involve my family or friends in the naming process?',
        answer: "Involving loved ones can be a great idea! They might offer unique perspectives and suggestions you hadn't considered. It can also be a fun bonding experience for everyone involved.",
    },
    {
        question: 'Are there any naming trends I should be aware of?',
        answer: 'Trends in dog names often mirror trends in popular culture. Pay attention to current events, movies, TV shows, and even social media for inspiration. Just ensure the name you choose will remain timeless and relevant to you.',
    },
    {
        question: "Can I wait to see my dog's personality before choosing a name?",
        answer: 'Absolutely! Spending time with your dog can reveal quirks and traits that might inspire the perfect name. Sometimes, waiting a few days or weeks can lead to a name that feels just right.',
    },
    {
        question: 'Should I consider the meaning behind a name?',
        answer: "The meaning behind a name can add depth and significance to your choice. You might explore names with meanings that reflect your dog's personality traits or your hopes for your relationship with them.",
    },
];
